<style lang="scss" scope>
.page-setting-guideshopshelf {
  position: relative;
  .edit-container {
    .edit-con {
      display: flex;
      width: 1500px;
    }
  }
  .setting-main {
    width: 600px;
  }
  .setting-prop {
    margin-left: 20px;
    .el-button-group {
      width: 100%;
      margin-bottom: 10px;
      .el-button {
        width: 125px;
      }
    }
    .preview-img {
      background-size: cover;
      width: 375px;
      height: 705px;
    }
    .preview-home {
      // background-image: url(../../assets/img/u9.png);
    }
    .preview-card {
      // background-image: url(../../assets/img/u13.png);
    }
    .preview-customer {
      background-image: url(../../assets/img/u14.png);
    }
  }
  .block-con {
    @include border-shadow();
    border-radius: 6px;
    background: #fff;
    margin-bottom: 20px;
    padding: 10px 5px;
    > .hd {
      display: flex;
      justify-content: space-between;
      padding: 10px 10px 5px;
      .title {
        color: #333;
        font-weight: 600;
      }
      .desc {
        font-size: 12px;
        color: $color-hint-text;
      }
    }
    > .bd {
      display: flex;
      padding: 0 5px 10px;
      .theme {
        flex: 1;
        background: #f2f2f2;
        margin: 0 5px;
        padding: 10px;
        border-radius: 4px;
        .theme-hd {
          font-size: 13px;
          font-weight: 600;
          color: #333;
          margin-bottom: 10px;
        }
        .theme-bd {
          .group-btn {
            margin-bottom: 20px;
          }
        }
      }
      .nav {
        flex: 1;
        background: #f2f2f2;
        margin: 0 5px;
        padding: 10px;
        border-radius: 4px;
        .theme-hd {
          font-size: 13px;
          font-weight: 600;
          color: #333;
          margin-bottom: 10px;
        }
      }
    }
  }
  .nav-list {
    display: flex;
    flex-wrap: wrap;
    .nav-item-wrap {
      width: 279px;
      background: #f2f2f2;
      box-sizing: border-box;
      border-radius: 3px;
      &:nth-child(1) {
        margin: 0px 5px 10px;
      }
      &:nth-child(2) {
        margin: 0px 5px 10px;
      }
      &:nth-child(3) {
        margin: 0px 5px;
      }
      &:nth-child(4) {
        margin: 0px 5px;
      }
      &:nth-child(5) {
        margin: 10px 5px 0 5px;
      }
      &:nth-child(6) {
        margin: 10px 0px 0px 5px;
      }
    }
  }
  .brand-list {
    display: flex;
    flex-wrap: wrap;
    .brand-item-wrap {
      width: 279px;
      background: #f2f2f2;
      border-radius: 3px;
      box-sizing: border-box;
      &:nth-child(1) {
        margin: 0px 5px 10px;
      }
      &:nth-child(2) {
        margin: 0px 5px 10px;
      }
      &:nth-child(3) {
        margin: 0px 5px;
      }
      &:nth-child(4) {
        margin: 0px 5px;
      }
    }
  }
  .tabbar-item {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    margin-bottom: 20px;
    background: #fff;
    padding: 4px 10px;
    .btn-edit {
      color: #409eff;
      cursor: default;
      cursor: pointer;
    }
  }
  .nav-edit-block {
    margin-left: 20px;
  }

  .theme-color-block {
    padding: 10px;
    background: #fff;
    .default-theme {
      display: flex;
      justify-content: space-between;
      .primary {
        width: 30px;
        height: 20px;
      }
      .second {
        width: 30px;
        height: 20px;
      }
      .theme-title {
        font-size: 13px;
      }
      .theme-wrap {
        display: flex;
        border: 1px solid $color-border-gray-light;
        padding: 1px;
        &.active {
          border-color: #409eff;
        }
      }
    }
    .custom-theme {
      display: flex;
      .primary,
      .second {
        flex: 1;
        display: flex;
        align-items: center;
      }
      .color-info {
        font-size: 12px;
        line-height: 16px;
        margin-left: 6px;
      }
    }
  }
}
</style>
<template>
  <div class="page-setting-guideshopshelf">
    <div class="edit-container">
      <div class="edit-con">
        <div class="setting-main">
          <div class="block-con">
            <div class="hd">
              <span class="title">全局设置</span>
              <span class="desc">该配置决定导购货架整体高亮色/辅助色</span>
            </div>
            <div class="bd">
              <div class="theme">
                <div class="theme-hd">
                  风格配色
                </div>
                <div class="theme-bd">
                  <groupBtn
                    v-model="contentColor"
                    label="内容颜色"
                    :btns="[
                      { name: '白', value: 1 },
                      { name: '黑', value: 2 }
                    ]"
                  />

                  <groupBtn
                    v-model="theme"
                    label="色系"
                    :btns="[
                      { name: '默认', value: 1 },
                      { name: '自定义', value: 2 }
                    ]"
                  />

                  <div class="theme-color-block">
                    <div
                      v-if="theme == 1"
                      class="default-theme"
                    >
                      <div
                        v-for="(theme, index) in themeColors"
                        :key="`theme-item__${index}`"
                        class="theme-item"
                      >
                        <div class="theme-title">
                          {{ theme.label }}
                        </div>
                        <div
                          class="theme-wrap"
                          :class="{ active: themeColor && theme.id == themeColor.id }"
                          @click="handleSelectTheme(theme)"
                        >
                          <div
                            class="primary"
                            :style="{ backgroundColor: theme.primaryColor }"
                          />
                          <div
                            class="second"
                            :style="{ backgroundColor: theme.secondaryColor }"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="theme == 2"
                      class="custom-theme"
                    >
                      <div class="primary">
                        <el-color-picker
                          v-model="themeCoustomerColor.primaryColor"
                          size="medium"
                        />
                        <div class="color-info">
                          <div class="name">
                            主题颜色
                          </div>
                          <div class="value">
                            {{ themeCoustomerColor.primaryColor }}
                          </div>
                        </div>
                      </div>
                      <div class="second">
                        <el-color-picker
                          v-model="themeCoustomerColor.secondaryColor"
                          size="medium"
                        />
                        <div class="color-info">
                          <div class="name">
                            辅助颜色
                          </div>
                          <div class="value">
                            {{ themeCoustomerColor.secondaryColor }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="nav">
                <div class="theme-hd">
                  底部导航
                </div>
                <div class="theme-bd">
                  <draggable
                    v-model="tabbars"
                    @start="onStart"
                    @end="onEnd"
                  >
                    <transition-group>
                      <div
                        v-for="(item, index) in tabbars"
                        :key="`tabbar-item__${index}`"
                        class="tabbar-item"
                      >
                        <span><i
                          style="cursor: move; line-height: 20px"
                          class="el-icon-s-unfold"
                        />{{
                          item.label
                        }}</span>
                        <span
                          class="btn-edit"
                          @click="handleEditTabbarItem(index)"
                        >编辑</span>
                      </div>
                    </transition-group>
                  </draggable>
                </div>
              </div>
            </div>
          </div>
          <div class="block-con">
            <div class="hd">
              <span class="title">首页快捷菜单</span>
              <span class="desc">将在导购信息下展示；方便导购快速展开业务</span>
            </div>
            <div class="bd nav-list">
              <div
                v-for="(nav, index) in navs"
                :key="`nav-item__${index}`"
                class="nav-item-wrap"
              >
                <navItem
                  :value="nav"
                  :label="titleMap[index]"
                  @reInitVal="reInitVal('navs-name', index)"
                />
              </div>
            </div>
          </div>
          <div class="block-con">
            <div class="hd">
              <span class="title">品牌展示</span>
            </div>
            <div class="bd brand-list">
              <div class="brand-item-wrap">
                <brandItem
                  v-if="brand.cover"
                  v-model="brand.cover"
                />
              </div>
              <div class="brand-item-wrap">
                <brandItem
                  v-if="brand.rank"
                  v-model="brand.rank"
                />
              </div>
              <div class="brand-item-wrap">
                <brandItem
                  v-if="brand.qrcode"
                  v-model="brand.qrcode"
                />
              </div>
            </div>
          </div>
        </div>
        <!--  -->
        <Preview
          :brand="brand"
          :navs="navs"
          :tabbars="tabbars"
          :primary-color="theme == 2 ? themeCoustomerColor.primaryColor : themeColor.primaryColor"
          :content-color="contentColor == 1 ? '#fff' : '#333'"
        />
        <div class="nav-edit-block">
          <!-- tabbarActive: {{tabbarActive}} -->
          <el-dialog
            :visible.sync="showType"
            width="340px"
          >
            <div>
              <tabbarEdit
                v-if="tabbarActive"
                v-model="tabbarActive"
                @reInitVal="reInitVal('tabbars-label', tabbarActive.index)"
              />
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
    <div class="fotter-toolbar">
      <el-button
        type="primary"
        @click="handleSaveSetting"
      >
        保存
      </el-button>
    </div>
  </div>
</template>

<script>
import groupBtn from './comps/groupBtn'
import tabbarEdit from './comps/tabbarEdit'
import navItem from './comps/navItem'
import brandItem from './comps/brandItem'
import Preview from './comps/Preview'

// 第三方组件
import draggable from 'vuedraggable'

import {
  defaultIconPath,
  defalutTabbars,
  defaultThemeColors,
  defaultMenus,
  defaultBrand,
  defalutData,
  titleMap
} from './guideShopshelf.conig'
import { config } from 'aws-sdk'

console.log('[defalutData]', defalutData)
export default {
  components: {
    groupBtn,
    tabbarEdit,
    navItem,
    brandItem,
    draggable,
    Preview
  },
  data () {
    return {
      titleMap,
      // 内容颜色
      contentColor: 1,
      // 色系
      theme: 1,
      // 默认主题
      themeColors: [
        { id: 1, label: '风格1', primaryColor: '#ff0000', secondaryColor: '#00ff00' },
        { id: 2, label: '风格2', primaryColor: '#00bb12', secondaryColor: '#123456' },
        { id: 3, label: '风格3', primaryColor: '#aeaeae', secondaryColor: '#888888' }
      ],
      themeColor: {},
      themeCoustomerColor: {
        primaryColor: '#ff0000',
        secondaryColor: '#00ff00'
      },
      // 底部导航,
      tabbars: defalutTabbars,
      tabbarActive: null,
      // 首页快捷菜单
      navs: [],
      // 品牌展示
      brand: {},
      previewBtn: 1,
      //配置项数据
      PreviewConfig: {
        //首页配置项
        homeConfig: {
          headBack: '',
          text: '',
          tabBar: '',
          topBack: ''
        },
        cardConfig: {},
        customerConfig: {},
        tabBarConfig: {}
      },
      showType: false
    }
  },
  watch: {
    brand: {
      deep: true,
      handler: function (val, oldVal) {
        console.log('brand-Change', { ...val })
      }
    },
    tabbarActive (Val, oVal) {
      if (Val) this.showType = true
      else this.showType = false
    },
    showType (Val) {
      if (!Val) this.tabbarActive = null
    }
  },
  created () {
    this.getPageSetting()
  },
  methods: {
    async getPageSetting () {
      let res = await this.$api.setting.getPageSetting()
      if (res.length == 0 || !res) res = defalutData
      // console.log('getPageSetting', res)
      res.qrcode = res.qrcode ? res.qrcode : { background: {} }

      const { global, index, qrcode } = res
      const { tabbar, style } = global
      this.globalSetting = res

      // 风格配色
      this.contentColor = style.config.textColor ? style.config.textColor.type : 1
      this.theme = style.config.themeColor ? style.config.themeColor.type : 1
      if (style.config.themeColor) {
        if (style.config.themeColor.type == 1) {
          this.themeColor = {
            id: style.config.themeColor.id,
            primaryColor: style.config.themeColor.primaryColor,
            secondaryColor: style.config.themeColor.secondaryColor
          }
        } else {
          this.themeCoustomerColor = {
            primaryColor: style.config.themeColor.primaryColor,
            secondaryColor: style.config.themeColor.secondaryColor
          }
        }
      }
      // console.log('tabbar.config', tabbar.config)
      // 底部导航
      this.tabbars =
        tabbar.config && tabbar.config.length > 0
          ? defalutTabbars.map((d, idx) => {
              if (tabbar.config && tabbar.config[idx].defaultHighIcon) {
                delete tabbar.config[idx].defaultHighIcon
                delete tabbar.config[idx].defaultIcon
              }
              return Object.assign(d, tabbar.config[idx])
            })
          : // tabbar.config.map((d,idx) => {
            //   delete d.defaultHighIcon
            //   delete d.defaultIcon
            //   return Object.assign({}, d, {
            //     defaultHighIcon: defalutTabbars[idx].defaultHighIcon,
            //     defaultIcon: defalutTabbars[idx].defaultIcon
            //   })
            // })
            defalutTabbars

      // 首页
      const { menu, cover, rank } = index
      console.log('menu.config', menu.config)
      this.navs =
        menu.config && menu.config.length > 0
          ? // defaultMenus.map((d, idx) => {
            //     if (menu.config && menu.config[idx].defaultMenusIcon) {
            //       delete menu.config[idx].defaultMenusIcon
            //     }
            //     return Object.assign(d, menu.config[idx])
            //   })
            menu.config.map((d, idx) => {
              delete d.defaultMenusIcon
              return Object.assign({}, d, { defaultMenusIcon: defaultMenus[idx].defaultMenusIcon })
            })
          : defaultMenus

      this.brand = {
        cover: cover.config || defaultBrand.cover,
        rank: rank.config || defaultBrand.rank,
        qrcode: qrcode.background.config || defaultBrand.qrcode
      }
      this.PreviewConfig.homeConfig.headBack = this.brand.cover
      console.log('this.brand', this.brand)
      console.log('[底部导航]-tabbars', this.tabbars)
      console.log('[首页快捷菜单]-navs', this.navs)
      console.log('this.themeColor', this.themeColor)
    },
    handleSelectTheme (theme) {
      this.themeColor = theme
    },
    handleClickBtn (index) {
      this.previewBtn = index
    },
    // 编辑某一个 tab - item
    handleEditTabbarItem (index) {
      this.tabbars[index].index = index
      this.tabbarActive = this.tabbars[index]
      // this.showType = true
    },

    // 保存配置
    async handleSaveSetting () {
      console.log(this.globalSetting)
      const { style, tabbar } = this.globalSetting.global
      // 风格配色
      style.config = {
        textColor: {
          type: this.contentColor,
          color: this.contentColor == 1 ? '#fff' : '#000'
        },
        themeColor: {
          type: this.theme,
          primaryColor:
            this.theme == 1 ? this.themeColor.primaryColor : this.themeCoustomerColor.primaryColor,
          secondaryColor:
            this.theme == 1
              ? this.themeColor.secondaryColor
              : this.themeCoustomerColor.secondaryColor,
          id: this.theme == 1 ? this.themeColor.id : null
        }
      }

      // 底部导航
      tabbar.config = this.tabbars

      // 快捷菜单
      const { menu, cover, rank } = this.globalSetting.index

      if (!this.cheack(this.navs, 'name', '首页快捷菜单不允许为空!')) return

      menu.config = this.navs

      // 品牌展示
      cover.config = this.brand.cover
      rank.config = this.brand.rank

      const { background } = this.globalSetting.qrcode
      background.config = this.brand.qrcode

      const { status } = await this.$api.setting.postPageSetting({
        config: JSON.stringify(this.globalSetting)
      })
      if (status) {
        this.$message.success('保存成功')
      }
    },
    // merge
    cheack (datas, key, errmsg) {
      let type = true
      datas.forEach((d) => {
        if (!d[key]) type = false
      })
      if (!type) this.$message.error(errmsg)
      return type
    },
    //恢复默认值
    reInitVal (key, index) {
      let keys = key.split('-')
      this[keys[0]][index][keys[1]] = this[keys[0]][index].default
      if (this[keys[0]][index].icon || this[keys[0]][index].defaultMenusIcon)
        this[keys[0]][index].icon = ''
    },
    // 拖拽绑定事件
    onStart (evt) {
      console.log(evt)
    },
    onEnd (evt) {
      console.log(evt)
    }
  }
}
</script>
